import React from "react";
import EpujaCard from "../../components/cards/EpujaCard";
import MobileHeader from "../../layout/MobileHeader";
import Icon from "../../components/Icon";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import OfferCard from "../../components/cards/OfferCard";
import MobileHeaderSearch from "../../components/MobileHeaderSearch";

import headerImg from '../../assets/images/topLocationHeader.png'
import { Link } from "react-router-dom";

const Epuja = ({ data, filters = {}, setFilters = () => {} }) => {
  return (
    <>
      <MobileHeader himage={headerImg} height="237px" >
        <MobileHeaderSearch placeholder="search for puja/hawan" onSearch={ search => setFilters({ ...filters, search })}/>
      </MobileHeader>

      <section style={{ marginTop: "270px" }}>
        <div className="e-puja-section">
          <h3 className="my-5 text-center custom-text-color">
            Find Your Remedy For Peace & Prosperety
          </h3>
        </div>

        {filters.search && <h4 className="ps-3">Search: { filters.search } <Icon icon={faXmark} className="ms-3" onClick={() => setFilters({})} /></h4>}
        <div className="container">
          <div className="row">
            {data.data?.map((puja, i) =>
              <div className="col-md-6 col-sm-12 p-0">
                <EpujaCard data={puja} />
              </div>
            )
            }
          </div>
        </div>

        {/* offers */}
        <div className="offers">
          <div className="row mx-0 px-3 pt-5">
            
              <div className="top-heading">Offers Tailored For You</div>
            
          </div>

          <div className="row  mx-0 my-2 ">
            <ul className="list-unstyled d-flex offers-card-list-mobile  mobileScrollBar">
              <li className="m-2">
                <div className="bg-dark rounded offers-card-container">
                  <OfferCard data={"Get upto 15% off on your First Booking"} />
                </div>
              </li>

              <li className="m-2">
                <div className="bg-dark rounded offers-card-container">
                  <OfferCard data={"Budget Friendly Homestays"} />
                </div>
              </li>
            </ul>

            <div className="col-md-6 d-flex justify-content-start sm-justify-content-end"></div>
          </div>

          <Link to={'/offers'} className=" d-flex justify-content-center">
            <div className=" w-50 primary-btn text-center">Know More</div>
          </Link>
        </div>

      </section>
    </>
  );
};

export default Epuja;
